
import React, { useState } from 'react';
import { Student } from '../types';

interface TransactionFormProps {
  students: Student[];
  onSubmit: (type: 'Pemasukan' | 'Pengeluaran', data: any) => void;
  isLoading: boolean;
}

const TransactionForm: React.FC<TransactionFormProps> = ({ students, onSubmit, isLoading }) => {
  const [type, setType] = useState<'Pemasukan' | 'Pengeluaran'>('Pemasukan');
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  
  const [studentName, setStudentName] = useState('');
  const [month, setMonth] = useState('');
  const [keperluan, setKeperluan] = useState('');

  const months = [
    'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 
    'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
  ];

  const getProp = (obj: any, ...keys: string[]) => {
    for (const key of keys) {
      if (obj[key] !== undefined) return obj[key];
      if (obj[key.toLowerCase()] !== undefined) return obj[key.toLowerCase()];
      const snake = key.replace(/\s/g, '_');
      if (obj[snake] !== undefined) return obj[snake];
      if (obj[snake.toLowerCase()] !== undefined) return obj[snake.toLowerCase()];
    }
    return undefined;
  };

  const handleStudentChange = (name: string) => {
    setStudentName(name);
    if (type === 'Pemasukan' && name !== '') {
      const selectedStudent = students.find(s => {
        const sName = getProp(s, 'Nama', 'nama', 'Nama_Siswa');
        return sName === name;
      });

      if (selectedStudent) {
        let iuranVal = getProp(selectedStudent, 'Iuran', 'iuran', 'Iuran_Kas');
        if (typeof iuranVal === 'string') {
          iuranVal = parseFloat(iuranVal.replace(/[^\d]/g, ''));
        }
        const finalAmount = iuranVal > 0 ? iuranVal : 20000;
        setAmount(finalAmount.toString());
      }
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!amount) return;

    if (type === 'Pemasukan') {
      if (!studentName || !month) return;
      onSubmit('Pemasukan', {
        tanggal: date,
        nama_siswa: studentName,
        jumlah: parseFloat(amount),
        bulan: month
      });
    } else {
      if (!keperluan) return;
      onSubmit('Pengeluaran', {
        tanggal: date,
        keperluan: keperluan,
        jumlah: parseFloat(amount)
      });
    }
    setAmount('');
    setKeperluan('');
    setStudentName('');
  };

  const inputClass = "w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm font-bold text-slate-700 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all placeholder-slate-400";
  const labelClass = "block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1.5 ml-1";

  return (
    <div>
      {/* Type Toggle */}
      <div className="flex bg-slate-100 p-1.5 rounded-xl mb-6">
         <button onClick={() => setType('Pemasukan')} className={`flex-1 py-2.5 rounded-lg text-xs font-bold uppercase tracking-wide transition-all ${type === 'Pemasukan' ? 'bg-white shadow-sm text-emerald-600' : 'text-slate-400'}`}>Pemasukan</button>
         <button onClick={() => setType('Pengeluaran')} className={`flex-1 py-2.5 rounded-lg text-xs font-bold uppercase tracking-wide transition-all ${type === 'Pengeluaran' ? 'bg-white shadow-sm text-rose-600' : 'text-slate-400'}`}>Pengeluaran</button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4 animate-enter">
        <div className="grid grid-cols-2 gap-4">
           <div>
              <label className={labelClass}>Tanggal</label>
              <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className={inputClass} />
           </div>
           <div>
              <label className={labelClass}>Nominal</label>
              <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} className={inputClass} placeholder="0" required />
           </div>
        </div>

        {type === 'Pemasukan' ? (
           <div className="space-y-4">
              <div>
                 <label className={labelClass}>Siswa</label>
                 <select value={studentName} onChange={(e) => handleStudentChange(e.target.value)} className={`${inputClass} appearance-none`} required>
                    <option value="">Pilih Siswa</option>
                    {students.map((s, i) => {
                       const name = getProp(s, 'Nama', 'nama', 'Nama_Siswa');
                       return <option key={i} value={name}>{name}</option>
                    })}
                 </select>
              </div>
              <div>
                 <label className={labelClass}>Untuk Bulan</label>
                 <select value={month} onChange={(e) => setMonth(e.target.value)} className={`${inputClass} appearance-none`} required>
                    <option value="">Pilih Bulan</option>
                    {months.map(m => <option key={m} value={m}>{m}</option>)}
                 </select>
              </div>
           </div>
        ) : (
           <div>
              <label className={labelClass}>Keperluan</label>
              <textarea value={keperluan} onChange={(e) => setKeperluan(e.target.value)} className={inputClass} placeholder="Detail pengeluaran..." rows={3} required></textarea>
           </div>
        )}

        <button 
           type="submit" 
           disabled={isLoading} 
           className={`w-full py-4 rounded-xl text-white font-bold text-xs uppercase tracking-widest mt-2 transition-all active:scale-95 shadow-lg ${type === 'Pemasukan' ? 'bg-emerald-500 hover:bg-emerald-600 shadow-emerald-200' : 'bg-rose-500 hover:bg-rose-600 shadow-rose-200'}`}
        >
           {isLoading ? <i className="fa-solid fa-spinner fa-spin"></i> : 'SIMPAN TRANSAKSI'}
        </button>
      </form>
    </div>
  );
};

export default TransactionForm;
